import {
  Bell,
  CarFront,
  FileChartColumn,
  FileClock,
  FileText,
  Gauge,
  HandCoins,
  LayoutGrid,
  LucideIcon,
  Route,
  Settings,
  Shield,
  SmartphoneNfc,
  Sparkles,
  Truck,
  Users,
  Video,
} from "lucide-react";

const iconMap: { [key: string]: LucideIcon } = {
  LayoutGrid: LayoutGrid,
  CarFront: CarFront,
  Users: Users,
  FileText: FileText,
  Settings: Settings,
  Bell: Bell,
  Truck: Truck,
  Shield: Shield,
  FileChartColumn: FileChartColumn,
  FileClock: FileClock,
  Video: Video,
  HandCoins: HandCoins,
  Route: Route,
  SmartphoneNfc: SmartphoneNfc,
  Gauge: Gauge,
  Sparkles: Sparkles,
};

export default iconMap;
